import styles from "../../ModalCriarRota/ModalCriarRota.module.css";
import { Field, Form, Formik } from "formik";
import Button from "../../../../../components/components-ui/Button/Button";
import { Col, Grid } from "../../../../../components/Grid";
import Select from "react-select";
import api from "../../../../../services/Api";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Loading from "../../../../../components/components-ui/Loading/Loading";
import { Table } from "../../../../../components/Table";
import InputClear from "../../../../../components/components-ui/InputClear/InputClear";
import { useOrdenacao } from "../../../../../utils/useOrdenacao";

const API_COLETAS_RECADO = "/painelfreguesia/listacoletarecado";
const API_ADICIONAR_COLETA = "/freguesia/adicionarcoletarecado";

const columnsColetas = [
  {
    column: "Selecionar",
    key: "acoes",
  },
  {
    column: "Nº Coleta",
    key: "IdColeta",
  },
  {
    column: "Data Agendamento",
    key: "DataAgendamento",
  },
  {
    column: "Freg",
    key: "Freg",
  },
  {
    column: "Dia",
    key: "DiaRetirada",
  },
  {
    column: "Est. Vol. Óleo",
    key: "Quantidade",
  },
  {
    column: "Marca",
    key: "Marca",
  },
  {
    column: "CEP",
    key: "CEP",
  },
  {
    column: "Logradouro",
    key: "Logradouro",
  },
];

function AdicionarRecadoAFreguesia({
  closeModal,
  idOc,
  freguesia,
  setLocaisDaRota,
  setDataLocaisFiltrados,
}) {
  const [coletasRecado, setColetasRecado] = useState([]);
  const [coletasRecadoFiltrados, setColetasRecadoFiltrados] = useState([]);
  const [locaisSelecionados, setLocaisSelecionados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputFilter, setInputFilter] = useState("");

  const [inputsFilter, setInputsFilter] = useState({
    IdColeta: "",
    DataAgendamento: "",
    Freg: "",
    DiaRetirada: "",
    Quantidade: "",
    Marca: "",
    CEP: "",
    Logradouro: "",
  });
  const [changeField, setChangeField] = useState("");

  const handleInputChange = (field, input) => {
    setInputsFilter((prev) => ({ ...prev, [field]: input }));
    setChangeField(field);
  };

  const handleClickClearInput = (field) => {
    setInputsFilter((prev) => ({ ...prev, [field]: "" }));
  };

  useEffect(() => {
    const coletas = coletasRecado.filter((coleta) => {
      return Object.entries(inputsFilter).every(([field, value]) => {
        if (!value) return true;
        const coletaValue = coleta?.[field];
        return coletaValue
          ?.toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      });
    });

    setColetasRecadoFiltrados(coletas);
  }, [inputsFilter, coletasRecado]);

  const { dados, ordenar, ordem, setDados } = useOrdenacao(
    coletasRecadoFiltrados,
    setColetasRecadoFiltrados
  );

  const getColetasRecado = async () => {
    setLoading(true);
    await api
      .get(API_COLETAS_RECADO)
      .then((res) => {
        if (res.data.error === 0) {
          setColetasRecado(res.data.data);
          setColetasRecadoFiltrados(res.data.data);
          return;
        }
        toast.error(res.data.msgError);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getColetasRecado();
  }, []);

  const adicionarColetaRecado = async () => {
    if (!locaisSelecionados.length) {
      toast.warn("Selecione ao menos uma coleta!");
      return;
    }

    await api
      .post(API_ADICIONAR_COLETA, {
        locais: locaisSelecionados,
        idOc,
        freguesia,
      })
      .then((res) => {
        console.log(res);
        if (res.data.error === 0) {
          toast.success(res.data.msg);
          setLocaisDaRota(res.data.data);
          setDataLocaisFiltrados(res.data.data);
          closeModal();
          return;
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  };

  const handleChangeSelecionar = (idLocal, idColeta) => {
    setLocaisSelecionados((prev) => {
      const isSelected = prev.find(
        (item) => item.idLocal === idLocal && item.idColeta === idColeta
      );
      return isSelected
        ? prev.filter(
            (i) => !(i.idLocal === idLocal && i.idColeta === idColeta)
          )
        : [...prev, { idLocal, idColeta }];
    });
  };

  //Filtro coletas recado
  const filterColetasRecado = (input) => {
    setInputFilter(input.toLowerCase());
    const coletas = coletasRecado.filter(
      (coletas) =>
        coletas?.Logradouro?.toString().toLowerCase().includes(input) ||
        coletas?.Marca?.toString().toLowerCase().includes(input) ||
        coletas?.IdLocal?.toString().toLowerCase().includes(input) ||
        coletas?.IdColeta?.toString().toLowerCase().includes(input) ||
        coletas?.DataAgendamento?.toString().toLowerCase().includes(input) ||
        coletas?.CEP?.toString().toLowerCase().includes(input)
    );
    setColetasRecadoFiltrados(coletas);
  };

  return (
    <div className={styles.modal_container}>
      <div
        className={`${styles.filter_container} ${styles.container_filter_recado}`}
      >
        <h3 style={{ textAlign: "center" }}>
          Adicionar Coleta Recado a Freguesia ({freguesia})
        </h3>
        {/* {coletasRecado.length ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span>Filtrar: </span>
            <InputClear
              type="text"
              value={inputFilter}
              onChange={(e) => filterColetasRecado(e.target.value)}
              onClick={() => {
                setInputFilter("");
                setColetasRecadoFiltrados(coletasRecado);
              }}
            />
          </div>
        ) : null} */}
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={{}}
        onSubmit={() => adicionarColetaRecado()}
      >
        {({ errors, touched, values, isSubmitting, isValid, setFieldValue }) =>
          loading ? (
            <div className={styles.loading_container}>
              <Loading />
            </div>
          ) : (
            <Form>
              <div>
                <Grid>
                  <Col>
                    <div className={styles.table_size}>
                      <Table
                        columns={columnsColetas}
                        onSort={ordenar}
                        ordem={ordem}
                        sticky
                      >
                        <tr>
                          <td>Filtros:</td>
                          <td>
                            <InputClear
                              type="text"
                              value={inputsFilter.IdColeta}
                              onChange={(e) =>
                                handleInputChange("IdColeta", e.target.value)
                              }
                              onClick={() => {
                                handleClickClearInput("IdColeta");
                              }}
                            />
                          </td>
                          <td>
                            <InputClear
                              type="text"
                              value={inputsFilter.DataAgendamento}
                              onChange={(e) =>
                                handleInputChange(
                                  "DataAgendamento",
                                  e.target.value
                                )
                              }
                              onClick={() => {
                                handleClickClearInput("DataAgendamento");
                              }}
                            />
                          </td>
                          <td>
                            <InputClear
                              type="text"
                              value={inputsFilter.Freg}
                              onChange={(e) =>
                                handleInputChange("Freg", e.target.value)
                              }
                              onClick={() => {
                                handleClickClearInput("Freg");
                              }}
                            />
                          </td>
                          <td>
                            <InputClear
                              type="text"
                              value={inputsFilter.DiaRetirada}
                              onChange={(e) =>
                                handleInputChange("DiaRetirada", e.target.value)
                              }
                              onClick={() => {
                                handleClickClearInput("DiaRetirada");
                              }}
                            />
                          </td>
                          <td>
                            <InputClear
                              type="text"
                              value={inputsFilter.Quantidade}
                              onChange={(e) =>
                                handleInputChange("Quantidade", e.target.value)
                              }
                              onClick={() => {
                                handleClickClearInput("Quantidade");
                              }}
                            />
                          </td>
                          <td style={{ textAlign: "left" }}>
                            <InputClear
                              type="text"
                              value={inputsFilter.Marca}
                              onChange={(e) =>
                                handleInputChange("Marca", e.target.value)
                              }
                              onClick={() => {
                                handleClickClearInput("Marca");
                              }}
                            />
                          </td>
                          <td>
                            <InputClear
                              type="text"
                              value={inputsFilter.CEP}
                              onChange={(e) =>
                                handleInputChange("CEP", e.target.value)
                              }
                              onClick={() => {
                                handleClickClearInput("CEP");
                              }}
                            />
                          </td>
                          <td style={{ textAlign: "left" }}>
                            <InputClear
                              type="text"
                              value={inputsFilter.Logradouro}
                              onChange={(e) =>
                                handleInputChange("Logradouro", e.target.value)
                              }
                              onClick={() => {
                                handleClickClearInput("Logradouro");
                              }}
                            />
                          </td>
                        </tr>
                        {coletasRecadoFiltrados.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="checkbox"
                                onChange={() =>
                                  handleChangeSelecionar(
                                    item?.IdLocal,
                                    item?.IdColeta
                                  )
                                }
                              />
                            </td>
                            <td> {item?.IdColeta} </td>
                            <td> {item?.DataAgendamento} </td>
                            <td> {item?.Freg} </td>
                            <td>{item?.DiaRetirada}</td>
                            <td>{item?.Quantidade}</td>
                            <td style={{ textAlign: "left" }}>{item?.Marca}</td>
                            <td>{item?.CEP}</td>
                            <td style={{ textAlign: "left" }}>
                              {item?.Logradouro}
                            </td>
                          </tr>
                        ))}
                      </Table>
                    </div>
                  </Col>
                </Grid>
                <div className={styles.buttons_container}>
                  <Button
                    title="Adicionar coletas"
                    type="submit"
                    disabled={isSubmitting}
                    className={styles.button_sm}
                  />
                  <Button
                    title="Cancelar"
                    type="button"
                    disabled={isSubmitting}
                    onClick={() => closeModal()}
                    color={"secondary"}
                    className={styles.button_sm}
                  />
                </div>
                {isSubmitting && (
                  <div className={styles.loading_container}>
                    <Loading display={isSubmitting ? "block" : "none"} />
                  </div>
                )}
              </div>
            </Form>
          )
        }
      </Formik>
    </div>
  );
}

export default AdicionarRecadoAFreguesia;
